webpackJsonp([45615974079089],{

/***/ 379:
/***/ (function(module, exports) {

	module.exports = {"data":{"markdownRemark":{"html":"<p>Relaxation has so many physical and mental health benefits, yet it often feels out of reach.  I’m happy to have been a contributor to <a href=\"http://www.parentmap.com/article/take-it-easy-cut-the-mom-stress-and-love-yourself\">this great article</a> in ParentMap magazine.  Sharlyn Gehrs describes why relaxation is so important, and some simple ways to find it in our busy lives.</p>","frontmatter":{"path":"/post-relax-refocus","title":"Relax and Refocus","author":"Nicole Sharkey","date":"January 30, 2013"}}},"pathContext":{}}

/***/ })

});


// WEBPACK FOOTER //
// path---post-relax-refocus-75d9c656e156a6d34d08.js